import React from "react";
import About from "./About";
import BLog from "./BLog";
import Contact from "./Contact";
import Projects from "./Projects";
import Slider from "./Slider";

const Home = () => {
  return (
    <div className="px-2">
      <Slider />
      <div className="max-w-[1100px] mx-auto">
        <hr />
      </div>
      <About />
      <div className="max-w-[1100px] mx-auto">
        <hr />
      </div>
      <Projects />
      <div className="max-w-[1100px] mx-auto">
        <hr />
      </div>
      <BLog />
      <div className="max-w-[1100px] mx-auto">
        <hr />
      </div>
      <Contact />
    </div>
  );
};

export default Home;
